const carouselItems = [
  {
    title: '2026娱乐圈年度吃瓜大盘点',
    desc: '从顶流塌房到神级反转，今年最劲爆的娱乐事件全收录，导航123带你一站式回顾。',
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20concept%20with%20abstract%20spotlight%20and%20stage%20elements%20on%20a%20warm%20cream%20background%2C%20artistic%20minimalist%20composition%2C%20soft%20coral%20and%20amber%20color%20palette%2C%20editorial%20magazine%20style%2C%20clean%20elegant%20aesthetic&width=1200&height=600&seq=carousel-ent-01&orientation=landscape',
    tag: '吃瓜专题',
    tagColor: 'accent' as const,
  },
  {
    title: '618购物节导航攻略全集',
    desc: '各大平台优惠入口、比价工具、抢券技巧一应俱全，网址导航123助你省钱购物。',
    image: 'https://readdy.ai/api/search-image?query=Ecommerce%20shopping%20festival%20concept%20with%20abstract%20gift%20boxes%20and%20discount%20elements%20floating%20on%20a%20warm%20neutral%20background%2C%20minimalist%20design%2C%20soft%20orange%20and%20gold%20tones%2C%20clean%20modern%20aesthetic&width=1200&height=600&seq=carousel-shop-02&orientation=landscape',
    tag: '购物攻略',
    tagColor: 'primary' as const,
  },
  {
    title: '暑期追剧观影指南',
    desc: '热门影视剧综推荐，从国产良心到海外大片，上网导航为你整理最佳观影顺序。',
    image: 'https://readdy.ai/api/search-image?query=Film%20and%20entertainment%20concept%20with%20abstract%20cinema%20elements%20like%20popcorn%20and%20film%20reel%20on%20a%20warm%20cream%20background%2C%20minimalist%20artistic%20composition%2C%20soft%20coral%20accent%20touches%2C%20editorial%20style&width=1200&height=600&seq=carousel-film-03&orientation=landscape',
    tag: '影视推荐',
    tagColor: 'secondary' as const,
  },
  {
    title: '科技数码新品发布汇总',
    desc: '最新手机、笔记本、智能穿戴设备发布信息聚合，导航123直达官方预约和评测页面。',
    image: 'https://readdy.ai/api/search-image?query=Technology%20product%20launch%20concept%20with%20abstract%20digital%20device%20silhouettes%20on%20a%20warm%20minimal%20background%2C%20clean%20geometric%20shapes%2C%20soft%20amber%20and%20cream%20tones%2C%20modern%20editorial%20style&width=1200&height=600&seq=carousel-tech-04&orientation=landscape',
    tag: '科技前沿',
    tagColor: 'primary' as const,
  },
  {
    title: '出行旅游热门目的地推荐',
    desc: '夏季避暑、海边度假、城市探索——机票酒店比价导航和攻略一站式配齐。',
    image: 'https://readdy.ai/api/search-image?query=Travel%20and%20vacation%20concept%20with%20abstract%20landscape%20and%20suitcase%20elements%20on%20a%20warm%20cream%20background%2C%20minimalist%20design%2C%20soft%20coral%20and%20sand%20tones%2C%20editorial%20travel%20magazine%20aesthetic&width=1200&height=600&seq=carousel-travel-05&orientation=landscape',
    tag: '出行攻略',
    tagColor: 'accent' as const,
  },
  {
    title: '在线工具大全：办公效率翻倍',
    desc: 'PDF转换、图片处理、文档协作——50+实用在线工具导航入口一站收录。',
    image: 'https://readdy.ai/api/search-image?query=Productivity%20and%20digital%20tools%20concept%20with%20abstract%20interface%20and%20tool%20icons%20on%20a%20warm%20neutral%20background%2C%20clean%20minimalist%20composition%2C%20soft%20orange%20accent%20touches%2C%20modern%20workspace%20aesthetic&width=1200&height=600&seq=carousel-tools-06&orientation=landscape',
    tag: '效率工具',
    tagColor: 'secondary' as const,
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            精选深度专题内容，覆盖吃瓜、购物、影视、科技等热门领域
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/60 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[2/1] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  width="1200"
                  height="600"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${
                    item.tagColor === 'primary' ? 'bg-primary-500 text-background-50' :
                    item.tagColor === 'accent' ? 'bg-accent-500 text-background-50' :
                    'bg-secondary-500 text-background-50'
                  }`}>
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-semibold text-base md:text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}